import React from 'react';
import { connect } from 'react-redux';
import { Field, reduxForm, formValueSelector } from 'redux-form';
import { bindActionCreators } from 'redux';
import { SubmissionError } from 'redux-form';
import LoadingProgress from '../components/LoadingProgress'
import moment from 'moment';
import { fetchFaults } from '../actions/faults';
import { fetchCustomers } from '../actions/customers';
import { fetchMachines } from '../actions/machines';
import { renderInputField, renderSelectField } from '../utils/forms';

const validate = (values) => {
  const errors = {};
  const { Customer, StartDate, EndDate } = values;

  // A customer must be selected before a report can be generated
  if (!Customer) {
    errors.Customer = 'Selecciona un cliente';
  }

  if (StartDate && EndDate) {
    const startDate = moment(StartDate);
    const endDate = moment(EndDate);

    if (endDate.diff(startDate, 'months') > 0) {
      errors.EndDate = 'El rango máximo de consulta es de un mes.';
    }
  }

  return errors;
};

class FaultsReportFilterForm extends React.Component {
  constructor(props) {
    super(props);

    this.state = { loaded: false };

    this.submit = this.submit.bind(this);
  }

  componentDidMount() {
    const { role, fetchMachines, fetchCustomers } = this.props;

    fetchMachines();

    fetchCustomers();

    this.load(this.props);
  }

  componentWillReceiveProps(nextProps) {
    this.load(nextProps);
  }

  load(props) {
    const { machines, customers, faults } = props;

    if (!this.state.loaded && machines && customers) {
      this.setState({ loaded: true });
    }
  }

  submit(props) {

    const { fetchFaults } = this.props;

    // Guard: a customer is mandatory before fetching faults
    if (!props.Customer) {
      throw new SubmissionError({
        Customer: 'Selecciona un cliente',
        _error: 'Debes seleccionar un cliente para generar el informe.',
      });
    }

    return fetchFaults(
      props.Machine,
      props.Customer,
      props.StartDate,
      props.EndDate,
    ).then((response) => {
      if (response.error) {
        throw new SubmissionError({
          _error: response.error.message,
          ...response.error.fields,
        });
      }

      return response;
    });
  }

  render() {
    const { loaded } = this.state;
    const {
      error,
      submitting,
      invalid,
      handleSubmit,
      machines,
      customers,
    } = this.props;

    if (!loaded || !machines || !customers) {
      return <LoadingProgress />
    }

    const selectedCustomer = this.props.formValues && this.props.formValues.Customer;

    // When a customer is chosen, only show its machines in the machine filter
    const machineOptions = selectedCustomer
      ? machines.filter((m) => m.Customer && m.Customer._id === selectedCustomer)
      : machines;

    return (
      <form onSubmit={handleSubmit(this.submit)} className="report-filter">
        <div className="rf-field">
          <Field
            name="Customer"
            component={renderSelectField}
            label="Cliente *"
          >
            <option value="">— Selecciona cliente —</option>
            {customers &&
              customers
                .filter((customer) => customer.Type === 'GENERAL' || customer.Type === 'LICENCIA_BASICA' || customer.Type === 'LICENCIA_PRO')
                .sort((a, b) => a.Fullname.localeCompare(b.Fullname))
                .map((customer) => (
                  <option value={customer._id} key={customer._id}>
                    {customer.Fullname}
                  </option>
                ))}
          </Field>
        </div>
        <div className="rf-field">
          <Field
            name="Machine"
            component={renderSelectField}
            label="Máquina"
          >
            <option value="">Todas</option>
            {machineOptions.map((machine) => (
              <option value={machine._id} key={machine._id}>
                {machine.Serial} - {machine.Customer?.Fullname || 'None'}
              </option>
            ))}
          </Field>
        </div>
        <div className="rf-field">
          <Field
            name="StartDate"
            component={renderInputField}
            type="date"
            label="Desde"
          />
        </div>
        <div className="rf-field">
          <Field
            name="EndDate"
            component={renderInputField}
            type="date"
            label="Hasta"
          />
        </div>
        <div className="rf-btn-col">
          <span className="rf-cap-spacer" aria-hidden="true"></span>
          <button
            className="report-btn report-btn--generate"
            type="submit"
            disabled={submitting || invalid}
            title={invalid ? 'Selecciona un cliente' : 'Generar informe'}
          >
            <i className={`fas ${submitting ? 'fa-spinner fa-spin' : 'fa-sync'}`}></i>
            Generar
          </button>
        </div>
        {error && <div className="alert alert-danger mt-2 mb-0" style={{ flexBasis: '100%' }}>{error}</div>}
      </form>
    );
  }
}

FaultsReportFilterForm = reduxForm({
  form: 'FaultsReportFilterForm',
  validate,
})(FaultsReportFilterForm);

const selector = formValueSelector('FaultsReportFilterForm');

// Default date range: the last 7 days (today − 7d → today)
const defaultDateRange = () => {
  const end = new Date();
  const start = new Date();
  start.setDate(start.getDate() - 7);
  return {
    StartDate: start.toISOString().substring(0, 10),
    EndDate: end.toISOString().substring(0, 10),
  };
};

const mapStateToProps = (state) => ({
  machines: state.machines.machines,
  customers: state.customers.customers,
  faults: state.faults,
  role: state.auth.role,
  initialValues: {
    Machine: '',
    Customer: '',
    ...defaultDateRange(),
  },
  formValues: {
    Machine: selector(state, 'Machine'),
    Customer: selector(state, 'Customer'),
    StartDate: selector(state, 'StartDate'),
    EndDate: selector(state, 'EndDate'),
  }
});

const mapDispatchToProps = (dispatch) => ({
  fetchFaults: bindActionCreators(fetchFaults, dispatch),
  fetchMachines: bindActionCreators(fetchMachines, dispatch),
  fetchCustomers: bindActionCreators(fetchCustomers, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(FaultsReportFilterForm);